import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AUTH_CONFIG, AUTH_CONSTANTS } from './auth.config';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [{ provide: AUTH_CONFIG, useValue: AUTH_CONSTANTS }]
})
export class AuthenticationModule {}
